import React from 'react';
import styled, { css } from 'styled-components';
import { Responsive } from 'semantic-ui-react';
import { useState } from 'react';
import { validateEmail } from '../../utils/email';

const Container = styled.div`
  background-color: #e4ff5f;
  padding: 10px 10px 0 10px;
  text-align: center;
`;

const Button = styled.button`
  font-family: 'Montserrat', sans-serif;
  font-weight: bold;
  width: 215px;
  height: 60px;
  text-align: center;
  display: inline-block;
  cursor: pointer;
  background-color: #7b4bf6;
  font-size: 14px;
  color: #ffffff;
  border-radius: 6px;
  border: none;
  outline: none;
  margin-top: 30px;
  @media (max-width: 640px) {
    width: 100%;
  }
`;

const Input = styled.input<{ validate?: boolean }>`
  border: none;
  border-bottom: 4px solid #4a4a4a;
  width: 450px;
  height: 60px;
  margin-top: 20px;
  background: none;
  color: #000000;
  font-size: 20px;
  line-height: 30px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  ::placeholder {
    color: #72831b;
    opacity: 0.6;
    font-family: 'Montserrat', sans-serif;
    font-weight: normal;
  }
  :focus {
    border-bottom: 4px solid #7b4bf6;
    outline: none;
  }
  @media (max-width: 640px) {
    width: 100%;
    display: block;
  }
  ${props =>
    props.validate &&
    css`
      border-bottom: 4px solid #9f3a38;
      color: #9f3a38;
      ::placeholder {
        color: #9f3a38;
      }
      :focus {
        border-bottom: 4px solid #9f3a38;
      }
    `}
`;

export default ({ jumpTo }: { jumpTo: (email: string) => void }) => {
  const [email, setEmail] = useState('');

  return (
    <Container>
      <div className="container-box">
        <div
          style={{
            marginTop: 40,
            fontWeight: 500,
            fontFamily: 'lack, Montserrat, sans-serif'
          }}
        >
          <Responsive
            minWidth={1024}
            style={{ fontSize: 70, lineHeight: '86px' }}
          >
            <div>Sign up to start selling</div>
            <div>your products live</div>
          </Responsive>
          <Responsive
            minWidth={670}
            maxWidth={1023}
            style={{ fontSize: 70, lineHeight: '76px' }}
          >
            <div>Sign up to start</div>
            <div>selling your</div>
            <div>products live</div>
          </Responsive>
          <Responsive
            maxWidth={669}
            style={{ fontSize: 40, lineHeight: '49px' }}
          >
            <div>Sign up to start</div>
            <div>selling your</div>
            <div>products live</div>
          </Responsive>
        </div>
        <Input
          value={email}
          name="email"
          placeholder="Email Address"
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            const { value } = event.target;
            setEmail(value);
          }}
          validate={Boolean(email && !validateEmail(email))}
        />
        <div>
          <Button
            onClick={() => {
              if (!email || validateEmail(email)) {
                jumpTo(email);
              }
            }}
          >
            SUBMIT
          </Button>
        </div>
      </div>
    </Container>
  );
};
